import React from 'react';
import { useShop } from '../context/ShopContext';
import { Sparkles, Crown, Gem, Flame, Tag } from 'lucide-react';

export default function StoryHighlights() {
  const { storyHighlightsData, setActiveCategory, setIsCartOpen, applyCoupon, addToast } = useShop();

  const handleStoryClick = (story) => {
    if (story.badge === 'PROMO' || story.badge === 'ROYAL10') {
      applyCoupon('ROYAL10');
      setIsCartOpen(true);
    } else {
      setActiveCategory(story.category || 'all');
      const catalogEl = document.getElementById('catalog-section');
      if (catalogEl) {
        catalogEl.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  const stories = Array.isArray(storyHighlightsData) 
    ? storyHighlightsData 
    : (Array.isArray(storyHighlightsData?.stories) ? storyHighlightsData.stories : []);

  if (stories.length === 0) return null;

  return (
    <div style={{
      backgroundColor: '#ffffff',
      boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.1)',
      marginBottom: '10px',
      padding: '12px 0'
    }}>
      <div className="container">
        <div 
          className="hide-scrollbar"
          style={{
            display: 'flex',
            gap: '1.75rem',
            overflowX: 'auto',
            padding: '4px 8px',
            WebkitOverflowScrolling: 'touch',
            alignItems: 'center',
            justifyContent: 'space-between'
          }}
        >
          {stories.map((story) => (
            <div
              key={story.id}
              onClick={() => handleStoryClick(story)}
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '6px',
                cursor: 'pointer',
                flexShrink: 0,
                transition: 'transform 0.15s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                const label = e.currentTarget.querySelector('.fk-cat-title');
                if (label) label.style.color = '#2874f0';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                const label = e.currentTarget.querySelector('.fk-cat-title');
                if (label) label.style.color = '#212121';
              }}
            >
              {/* Flipkart Category Icon Bubble */}
              <div style={{
                width: '64px',
                height: '64px',
                borderRadius: '50%',
                padding: '2px',
                backgroundColor: '#ffffff',
                border: '1px solid #e0e0e0',
                boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <img
                  src={story.img}
                  alt={story.title}
                  style={{
                    width: '100%',
                    height: '100%',
                    borderRadius: '50%',
                    objectFit: 'cover',
                    display: 'block'
                  }}
                />

                {story.badge && (
                  <span style={{
                    position: 'absolute',
                    bottom: '-4px',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    backgroundColor: '#388e3c',
                    color: '#ffffff',
                    fontSize: '0.58rem',
                    fontWeight: 700,
                    padding: '1px 5px',
                    borderRadius: '2px',
                    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.2)',
                    whiteSpace: 'nowrap'
                  }}>
                    {story.badge}
                  </span>
                )}
              </div>

              {/* Flipkart Category Label */}
              <span 
                className="fk-cat-title"
                style={{
                  fontSize: '0.82rem',
                  fontWeight: 600,
                  color: '#212121',
                  textAlign: 'center',
                  maxWidth: '85px',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  transition: 'color 0.15s ease'
                }}
              >
                {story.title}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
